import { companiesService } from './service'
import { createFetchHook } from '../../acato-utils'

export const companiesHooks = createFetchHook(companiesService)
